<script setup lang="ts">
import {computed} from "vue";
const display = useDisplay();
const isLarge = computed(() => {
  return display.lgAndUp.value;
});
</script>

<template>
  <v-parallax
      :scale="0.5"
      :height="isLarge ? '700' : 'auto'"
      src="/images/multi-sport-banner.jpg"
  >
    <v-container class="h-100">
      <v-row class="h-100">

        <v-col cols="12"  class="d-flex flex-fill flex-column justify-center pa-7">
          <h2 class="a-title-large mb-4 text-white w-100">Download the app today</h2>
          <p class="mb-4 text-white text-h5">
            Download the app today and you can start to manage your clubs on the go.
          </p>
          <div class="d-flex flex-row align-content-start align-start w-100">
            <a href="https://apps.apple.com/us/app/squash-leagues-ladders/id1415056784" target="_blank">
              <v-img
                  alt="Link to Apple App Store"
                  class=""
                  contain
                  src="/images/apple_link.png"
                  width="150"
              />
            </a>
            <a href="https://play.google.com/store/apps/details?id=org.squashleagues.squashleaguesladders&hl=en&gl=US"
               target="_blank">
              <v-img
                  alt="Link to Google Play Store"
                  class=""
                  contain
                  src="/images/google_link.png"
                  width="160"
              />
            </a>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-parallax>
</template>

<style scoped lang="scss">

</style>
